/* Auto-generated from inline schema 2025-08-29T08:39:05.773Z */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'number',
      minimum: 0,
      maximum: 100,
    },
  },
  required: ['value'],
}

export const answerSchema = valueSchema
